var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsXWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#272B30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5891 12.4106C13.2637 12.0851 12.736 12.0851 12.4106 12.4106C12.0851 12.736 12.0851 13.2637 12.4106 13.5891L16.8213 17.9999L12.4106 22.4106C12.0852 22.736 12.0852 23.2637 12.4106 23.5891C12.736 23.9145 13.2637 23.9145 13.5891 23.5891L17.9998 19.1784L22.4106 23.5891C22.736 23.9145 23.2637 23.9145 23.5891 23.5891C23.9145 23.2637 23.9145 22.736 23.5891 22.4106L19.1784 17.9999L23.5891 13.5891C23.9146 13.2637 23.9146 12.736 23.5891 12.4106C23.2637 12.0851 22.736 12.0851 22.4106 12.4106L17.9998 16.8213L13.5891 12.4106Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsXWhite);
export default __webpack_public_path__ + "static/media/es_x_white.bdd19330e05978a7c4f6ba819a9c74dc.svg";
export { ForwardRef as ReactComponent };